/**
 * Cognito auth options for the shared FinSuite AppSync Events API.
 *
 * The upgrade-medic channels authorize connect/publish through `userPool` only — apiKey is not an
 * accepted provider on them. Passing `undefined` when no ID token is found silently degrades to
 * that apiKey default and surfaces as an opaque AppSync authorization error, so a missing session
 * throws here instead: "you are not signed in" is the failure the user can actually act on.
 */
import { fetchAuthSession } from 'aws-amplify/auth';

const DEFAULT_NO_SESSION_MESSAGE = 'No Cognito session — sign in again to run Upgrade Medic actions';

/** `noSessionMessage` names the action the caller was attempting, so the thrown error stays actionable. */
export const getEventsAuthOptions = async (
  noSessionMessage: string = DEFAULT_NO_SESSION_MESSAGE
): Promise<{ authMode: 'userPool'; authToken: string }> => {
  const idToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  if (!idToken) {
    throw new Error(noSessionMessage);
  }
  return { authMode: 'userPool', authToken: idToken };
};
